import React from 'react';

import NewsLetter from 'components/newsletter';

const NewsLetterContainer = () => {
  return (
    <div>
      <NewsLetter />
    </div>
  );
};

export default NewsLetterContainer;
